/* Consent is submitted directly to Klaviyo's public client subscription API.
 * No credentials, discount codes, or email addresses are stored locally. */
(() => {
  function init() {
    const dialog = document.querySelector('[data-rr-newsletter]');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const form = dialog.querySelector('[data-rr-signup-form]');
    const status = dialog.querySelector('[role="status"]');
    const button = form.querySelector('[type="submit"]');
    const submitLabel = button.textContent;
    const key = 'rr-newsletter-15-v1';
    const read = name => { try { return localStorage.getItem(name); } catch (_) { return null; } };
    const write = (name, value) => { try { localStorage.setItem(name, value); } catch (_) {} };
    let returnFocus;
    let openedAt = 0;
    let autoShown = false;
    const open = trigger => {
      if (dialog.open) return;
      returnFocus = trigger || document.activeElement;
      openedAt = Date.now();
      dialog.showModal();
      document.documentElement.classList.add('rr-signup-open');
      dialog.querySelector('[data-rr-close-signup]').focus();
    };
    const close = () => dialog.close();
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-rr-open-signup]');
      if (trigger) { event.preventDefault(); open(trigger); }
      if (event.target.closest('[data-rr-close-signup]')) close();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    dialog.addEventListener('close', () => {
      write(key + '-dismissed', String(Date.now()));
      document.documentElement.classList.remove('rr-signup-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
    const canAutoShow = () => dialog.dataset.rrEditor !== 'true' && dialog.dataset.rrSubscribed !== 'true' && read(key + '-subscribed') !== 'true' && Date.now() - Number(read(key + '-dismissed') || 0) > 7 * 86400000;
    const maybeOpen = () => {
      if (autoShown || !canAutoShow() || document.visibilityState !== 'visible') return;
      if (document.activeElement?.matches('input,textarea,select,[role="combobox"]') || document.querySelector('dialog[open], [data-rr-menu][open], .rr-select.is-open')) return;
      if (document.querySelector('[data-rr-product]') || /\/(products|cart|checkout|account|challenge)(\/|$)/.test(location.pathname)) return;
      autoShown = true;
      open();
    };
    const timer = setTimeout(maybeOpen, 18000);
    window.addEventListener('pagehide', () => clearTimeout(timer), {once:true});
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || button.disabled) return;
      if (form.elements.website.value || Date.now() - openedAt < 1500) {
        status.textContent = 'Please check your email address and try again.';
        return;
      }
      button.disabled = true;
      button.textContent = 'Signing you up…';
      status.textContent = '';
      const payload = {data:{type:'subscription',attributes:{custom_source:'R&R staging verified newsletter popup — double opt-in test',profile:{data:{type:'profile',attributes:{email:form.elements.email.value.trim(),subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:dialog.dataset.rrList}}}}};
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(dialog.dataset.rrCompany), {
          method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify(payload)
        });
        if (response.status !== 202) throw new Error('Subscription not accepted');
        write(key + '-subscribed', 'true');
        button.textContent = 'You’re on the list';
        status.textContent = 'One more step: check your inbox and confirm your email. After that, your signup is verified.';
        form.elements.email.disabled = true;
        document.querySelectorAll('.rr-signup-tab').forEach(el => { el.hidden = true; });
      } catch (_) {
        button.disabled = false;
        button.textContent = submitLabel;
        status.textContent = 'We couldn’t complete your signup. Please try again in a moment.';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
